module.exports = __webpack_public_path__ + "static/media/page18b.f80b4e51.png";